import React, { useState, useEffect } from "react";
import { PhotoIcon } from "@heroicons/react/24/solid";
import { authAxios } from "../../config/config";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { correctContactValue } from "../../Helper/helper";

const AddOutsideJordan = ({ handleCancel, handleAdd, allModel, handleUpdate }) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
    const [formData, setFormData] = useState({
        name: { en: "", ar: "" },
        description: { en: "", ar: "" },
        image: "",
        country: "",
        facebook: "",
        instagram: "",
        twitter: "",
        youtube: "",
        linkedin: "",
        email: "",
        contactNumber: ""
    });
    const currentLanguage = i18next.language

    const [allCountry, setallCountry] = useState([])


    const handleInputChange = (field, lang, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: typeof value === "object" ? value : { ...prev[field], [lang]: value },
        }));
    };

    const fetchTradingData = async () => {
        try {
            const response = await authAxios().get(
                `/admin/country`
            );
            const resData = response?.data;
            setallCountry(resData?.data?.country)
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const payload = { ...formData };

        console.log("payload", payload)
        if (allModel?.data?._id) {
            handleUpdate(payload);
        } else {
            handleAdd(payload);
        }
    };

    const handleProfileChange = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        try {
            const response = await authAxios().post("/admin/upload/single", formData);
            const resData = response.data;
            toast.success(resData.message);
            setFormData((prev) => ({ ...prev, image: resData.data.url }));
        } catch (error) {
            toast.error(error.response.data.message);
        }
    };

    useEffect(() => {
        fetchTradingData()
        if (allModel?.data?._id) {
            setFormData({
                name: allModel.data.name,
                description: allModel.data.description,
                image: allModel.data.image,
                country: allModel?.data?.country?._id,
                discountUrl: allModel.data.discountUrl,
                facebook: allModel.data.facebook,
                instagram: allModel.data.instagram,
                twitter: allModel.data.twitter,
                youtube: allModel.data.youtube,
                linkedin: allModel.data.linkedin,
                email: allModel.data.linkedin,
                contactNumber: allModel.data.contactNumber

            });
        }
    }, []);





    return (
        <div className="fixed inset-0 z-10">
            <div className="fixed inset-0 bg-gray-500/75 transition-opacity"></div>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-screen items-center justify-center p-4 sm:p-6 lg:p-8 text-center">
                    <div className="relative transform overflow-hidden bg-white rounded-lg shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                        <div className="px-6 py-8">
                            <h2 className="text-lg font-medium text-gray-900 mb-6">
                                {allModel?.data?._id ? "Update Outside Jordan " : "Add Outside Jordan"}
                            </h2>
                            <form onSubmit={handleSubmit} className="space-y-6">
                                {/* Title */}
                                {["name"].map((field) => (
                                    <div key={field} className="flex items-center gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">
                                            {field.charAt(0).toUpperCase() + field.slice(1)}
                                        </label>
                                        <input
                                            type="text"
                                            placeholder={`${field} (EN)`}
                                            required
                                            value={formData[field]?.en || ""}
                                            onChange={(e) => handleInputChange(field, "en", e.target.value)}
                                            className="w-3/4 flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                        <input
                                            type="text"
                                            placeholder={`${field} (AR)`}
                                            value={formData[field]?.ar || ""}
                                            onChange={(e) => handleInputChange(field, "ar", e.target.value)}
                                            required
                                            className="w-3/4 flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                        />
                                    </div>
                                ))}

                                {["description"].map((field) => (
                                    <div key={field} className="flex gap-4">
                                        <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">
                                            {field.charAt(0).toUpperCase() + field.slice(1)}
                                        </label>
                                        <div className="flex flex-col w-full">
                                            <textarea
                                                placeholder={`${field} (EN)`}
                                                value={formData[field]?.en || ""}
                                                onChange={(e) => handleInputChange(field, "en", e.target.value)}
                                                className=" mb-4 flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                rows={5}
                                            />
                                            <textarea
                                                placeholder={`${field} (AR)`}
                                                value={formData[field]?.ar || ""}
                                                onChange={(e) => handleInputChange(field, "ar", e.target.value)}
                                                className=" flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                                rows={5}
                                            />
                                        </div>
                                    </div>
                                ))}


                                <div className="flex items-center gap-4">
                                    <label
                                        htmlFor="country"
                                        className="w-1/4 block text-sm font-medium text-gray-700 text-justify"
                                    >
                                        Select Country
                                    </label>
                                    <select
                                        id="country"
                                        value={formData.country}
                                        onChange={(e) =>
                                            setFormData((prev) => ({ ...prev, country: e.target.value }))
                                        }
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    >

                                        <option value="">-- Select a Country --</option>

                                        {allCountry &&
                                            allCountry.map((country) => (
                                                <option key={country._id} value={country._id}>
                                                    {country?.name[currentLanguage]}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Email</label>
                                    <input
                                        type="text"
                                        placeholder="Enter email"

                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />

                                </div>

                                <div className="flex  gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Social Links</label>
                                    <div className="grid grid-cols-2 gap-4">
                                        {[
                                            { field: "facebook", label: "Facebook URL" },
                                            { field: "instagram", label: "Instagram URL" },
                                            { field: "twitter", label: "Twitter URL" },
                                            { field: "youtube", label: "Yotube URL" },
                                            { field: "linkedin", label: "LinkdedIn URL" },
                                        ].map(({ field, label }) => (
                                            <input
                                                key={field}
                                                type="text"
                                                placeholder={label}
                                                value={formData[field] || ""}
                                                onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
                                                className="w-full rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                            />
                                        ))}
                                    </div>
                                </div>
                                <div className="flex items-center gap-4">
                                    <label className="w-1/4 text-sm font-medium text-gray-900 text-justify">Contact Number</label>
                                    <input
                                        type="text"
                                        placeholder="Contact Number"
                                        value={formData.contactNumber}
                                        onChange={(e) => setFormData({ ...formData, contactNumber: correctContactValue(e.target.value) })}
                                        className="flex-1 rounded-md bg-white px-4 py-3 text-gray-900 border border-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 sm:text-sm"
                                    />
                                </div>
                                {/* Image Upload */}
                                <div className="grid grid-cols-12 gap-4">
                                    <div className="col-span-3">
                                        <label htmlFor="cover-photo" className="block text-sm font-medium text-gray-900 mb-2 text-justify">Image</label>
                                    </div>
                                    <div className="col-span-9">
                                        {formData.image === '' ? (
                                            <div className="flex flex-col items-center rounded-lg border border-dashed border-gray-300 px-4 py-4">
                                                <PhotoIcon aria-hidden="true" className="text-gray-300 h-12 w-12 mb-2" />
                                                <div className="flex items-center text-sm text-gray-600">
                                                    <label htmlFor="file-upload" className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500">
                                                        <span>Upload a file</span>
                                                        <input
                                                            id="file-upload"
                                                            name="file-upload"
                                                            type="file"
                                                            required
                                                            accept="image/jpeg,image/png,image/jpg"
                                                            onChange={handleProfileChange}
                                                            className="sr-only"
                                                        />
                                                    </label>
                                                    <p className="pl-2">or drag and drop</p>
                                                </div>
                                                <p className="mt-2 text-xs text-gray-500">PNG, JPG,JPEG up to 10MB</p>
                                            </div>
                                        ) : (
                                            <>
                                                <img
                                                    src={`${process.env.REACT_APP_IMAGE_URL}/${formData.image}`}
                                                    alt="Cover"
                                                    className="w-full h-40 object-cover rounded-lg mb-3"
                                                    loading="lazy"
                                                />

                                                <label
                                                    htmlFor="file-upload"
                                                    className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
                                                >
                                                    <span>Change Image</span>
                                                    <input
                                                        id="file-upload"
                                                        name="file-upload"
                                                        type="file"
                                                        accept="image/jpeg,image/png,image/jpg"
                                                        onChange={handleProfileChange}
                                                        className="sr-only"
                                                    />
                                                </label>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Submit Buttons */}
                                <div className="flex gap-2 mt-4">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="w-1/2 text-sm font-semibold text-gray-900 bg-gray-200 px-4 py-3 rounded-md shadow-sm hover:bg-gray-300"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="w-1/2 text-sm font-semibold text-white bg-indigo-600 px-4 py-3 rounded-md shadow-sm hover:bg-indigo-700"
                                    >
                                        {allModel?.data?._id ? "Update" : "Add"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddOutsideJordan;
